










































































import { AdgroupFormData, CampaignFormData, AudiencePackageItemStatus, CreateMode } from '@tt4b/ttam-enums';
import { StateEnum, useStore } from '@tt4b/ttam-hooks';
import { computed, defineComponent, PropType, ref, toRefs } from '@vue/composition-api';
import Audience from './index';
import TtamAudienceTagRelation from './audience-tag-relation/index.vue';
import TtamExpandButton from '@/components/common/expand-button/index.vue';
import TtamLabelOptional from '@/components/common/label-optional/index.vue';

const name = 'ttam-audience';
export default defineComponent({
  name,
  components: {
    TtamAudienceDmpSelect: Audience.TtamAudienceDmpSelect,
    TtamAudienceTagRelation,
    TtamExpandButton,
    TtamLabelOptional,
  },
  props: {
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    disabledTips: {
      type: String,
      default: '',
    },
    // NOTE: 埋点相关
    disabledTipsExpose: {
      type: Object,
      default: () => ({}),
    },
    isRetargeting: {
      type: Boolean,
      default: false,
    },
    enableTagRelation: {
      type: Boolean,
      default: false,
    },
    from: {
      type: String,
      default: '',
    },
    createMode: {
      type: String as PropType<CreateMode>,
      default: CreateMode.CREATE,
    },
  },
  setup(props, { emit }) {
    const { state } = useStore();
    const aadvid = computed(() => state[StateEnum.baseInfo].value.aadvid);
    const { adgroupData, campaignData, isRetargeting, enableTagRelation, from } = toRefs(props);
    const { retargetingAudienceValidator } = Audience.useRules();
    const { isProductSaleRetargeting, isProductSales } = Audience.useRetargetingIs({ adgroupData, campaignData });
    const { excludeSelectVisible, excludeSelectAvailable } = Audience.useExcludeSelectParams({
      adgroupData,
      campaignData,
      isRetargeting,
    });
    const { isSelectedIndustryType, isLoading, requestDMPInfo, includeSelectTreeProps, excludeSelectTreeProps } =
      Audience.useDmpInfoDataSource({
        adgroupData,
        campaignData,
        isRetargeting,
        isProductSales,
        from,
      });
    const { audienceIncludeLabel, audienceExcludeLabel } = Audience.useAudienceBaseLabel({
      isRetargeting,
      isProductSales,
    });

    const _customAudienceTagRelation = computed({
      get: () => adgroupData.value.customAudienceTagRelation,
      set: val => {
        if (enableTagRelation.value) {
          emit('tag-relation-change', val);
        }
      },
    });

    const _retargetingTags = computed({
      get: () => adgroupData.value.retargetingTags,
      set: val => {
        emit('include-change', val);
      },
    });
    const _retargetingTagsExclude = computed({
      get: () => adgroupData.value.retargetingTagsExclude,
      set: val => {
        emit('exclude-change', val);
      },
    });
    const { offlineExcludeTagTips, offlineIncludeTagTips } = Audience.useAudiencePackageTagOffline();

    // const { isControlGroup } = useSplitTestTool();
    const isControlGroup = ref(false);
    const createNewHref = Audience.useCommonCreateNewHref({ aadvid: aadvid.value });
    const buttonDisabled = computed(() => isControlGroup.value || props.disabled);

    const onIncludeChange = val => {
      emit('include-change', val);
    };
    const onExcludeChange = val => {
      emit('exclude-change', val);
    };
    const onRefresh = () => {
      if (isControlGroup.value) {
        return;
      }
      requestDMPInfo();
    };
    return {
      name,
      retargetingAudienceValidator,
      isSelectedIndustryType,
      isLoading,
      _customAudienceTagRelation,
      _retargetingTags,
      _retargetingTagsExclude,
      excludeSelectVisible,
      excludeSelectAvailable,
      includeSelectTreeProps,
      excludeSelectTreeProps,
      isControlGroup,
      createNewHref,
      buttonDisabled,
      audienceIncludeLabel,
      audienceExcludeLabel,
      offlineExcludeTagTips,
      offlineIncludeTagTips,
      isProductSaleRetargeting,
      isProductSales,
      requestDMPInfo,
      onIncludeChange,
      onExcludeChange,
      onRefresh,
    };
  },
});
